"use strict";
/**
 * Created on 06 23 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>Data transfer object encapsulating recalculation inputs related to recalculation of supplier agreement purchase prices. Entity
 * reflects nullable fields within {@link SupplierAgreement entity}.</p>
 *
 * <p><b>Start date of window validity is also needed for recalc in case that {@link SupplierAgreement.promoPurchaseStartDate} is not set.
 * It would be better to have {@link SupplierAgreement.promoPurchaseStartDate} always set (not nullable). In current situation, we need to
 * resolve promo cost start date from window validity. Window validity is not part of this entity, it is common to all associated items in
 * window. Resolving promo cost start date in case that {@link SupplierAgreement.promoPurchaseStartDate} is not set increases the total
 * number of entities we need to retrieve from data storage.</b></p>
 *
 * @author JMe
 */


var SupplierAgreementPricesRecalcInput =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SupplierAgreementPricesRecalcInput, _DomainObject_1$Domai);

  /**
   * CTor.
   *
   * @param aId Relates to {@link SupplierAgreement.id}.
   * @param wId Relates to {@link Window.id} to which belongs associated window item.
   * @param iId Relates to {@link SupplierAgreement.windowItemId}.
   * @param pId Relates to {@link Product.id} associated with window item. Part of the direct input for price calculation algorithm.
   * @param sId Relates to {@link SupplierAgreement.supplierId}. Part of the direct input for price calculation algorithm.
   * @param cId Relates to {@link SupplierAgreement.currencyId}. We compare the currency of price from price list with this value and if
   *        it differs, we recalculate the new price form price list to this currency using currency rate valid at {@link this.promoPFrom}
   *        and if this date is not set, we use the start validity of window - 16 days (number of days is configured param).
   * @param regPPrice Relates to {@link SupplierAgreement.regularPurchasePrice}.
   * @param regPPriceNett Relates to {@link SupplierAgreement.regularPurchasePriceNett}.
   * @param promoPPrice Relates to {@link SupplierAgreement.promoPurchasePrice}.
   * @param promoPPricePlus Relates to {@link SupplierAgreement.promoPurchasePricePlus}.
   * @param promoPFrom Relates to {@link SupplierAgreement.promoPurchaseStartDate}.
   * @param lastPromoPurchaseUpdate Relates to {@link SupplierAgreement.lastPromoPurchaseUpdate}.
   */
  function SupplierAgreementPricesRecalcInput(aId, wId, iId, pId, sId, cId, regPPrice, regPPriceNett, promoPPrice, promoPPricePlus, promoPFrom, lastPromoPurchaseUpdate) {
    var _this;

    _classCallCheck(this, SupplierAgreementPricesRecalcInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementPricesRecalcInput).call(this));
    _this.aId = aId;
    _this.wId = wId;
    _this.iId = iId;
    _this.pId = pId;
    _this.sId = sId;
    _this.cId = cId;
    _this.regPPrice = regPPrice;
    _this.regPPriceNett = regPPriceNett;
    _this.promoPPrice = promoPPrice;
    _this.promoPPricePlus = promoPPricePlus;
    _this.promoPFrom = promoPFrom;
    _this.lastPromoPurchaseUpdate = lastPromoPurchaseUpdate;
    return _this;
  }

  return SupplierAgreementPricesRecalcInput;
}(DomainObject_1.DomainObject);

exports.SupplierAgreementPricesRecalcInput = SupplierAgreementPricesRecalcInput;